<template>
  <v-autocomplete
    clearable
    :disabled="tagType === null || loading"
    :items="!isGetID ? leagues : leagueList"
    :loading="loading"
    v-bind="attributes"
    v-on="listeners"
  />

</template>
<script>
import { mapActions, mapState } from 'vuex'
import map from 'lodash/map'

export default {
  props: {
    tagType: {
      type: String,
      required: false
    },
    isNotMultiple: {
      type: Boolean,
      required: false
    },
    isGetID: {
      type: Boolean,
      required: false
    },
    errorMessage: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: false
    }
  },
  watch: {
    tagType: {
      immediate: true,
      handler: 'getLeagues'
    },
    loading (value) {
      this.$emit('loadingState', value)
    }
  },
  computed: {
    ...mapState({
      leagues: state => map(state.tag.list, 'name'),
      league_list: state => state.tag.list
    }),
    leagueList () {
      let list = []
      this.league_list.forEach((value) => {
        list.push({
          text: value.name,
          value: value.id
        })
      })
      return list
    },
    attributes () {
      return {
        label: 'League',
        multiple: !this.isNotMultiple,
        outlined: true,
        'error-messages': this.errorMessage,
        ...this.$attrs
      }
    },
    listeners () {
      return {
        ...this.$listeners
      }
    }
  },
  methods: {
    ...mapActions({
      getTags: 'tag/getTags'
    }),
    async getLeagues () {
      try {
        this.loading = true
        this.errorMessage = null
        if (this.tagType) {
          if (this.tagType === 'all') {
            await this.getTags({})
          } else {
            await this.getTags({ withType: this.tagType })
          }
        }
      } catch (err) {
        this.errorMessage = 'Unable to retrieve data.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
